import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

import { ButtonsWrapper } from './NewLocationConfirmation.style';

interface MapControlsProps {
  onAddClick?: () => void;
  onCancelClick?: () => void;
}

export function NewLocationConfirmation({ onAddClick, onCancelClick }: MapControlsProps) {
  const { formatMessage } = useIntl();
  return (
    <ButtonsWrapper>
      <ButtonUI
        icon="fal fa-xmark"
        onClick={onCancelClick}
        size="small"
        text={formatMessage({
          defaultMessage: 'Quit',
          id: 'common.quit'
        })}
        type="tertiary"
      />
      <ButtonUI
        icon="fal fa-plus"
        onClick={onAddClick}
        size="small"
        text={formatMessage({
          defaultMessage: 'Add Location',
          id: 'mapPopup.addLocation'
        })}
      />
    </ButtonsWrapper>
  );
}
